import { computed, useContext, ref, onMounted, onUnmounted } from '@nuxtjs/composition-api'
import { useMobile } from './useMobile'
import { useStickyComponent } from './useStickyComponent'
import { usePdpStore } from '~/store/pdp'

/**
 * Wrapper function around the `useStickyComponent` composable to be used for PDP components.
 * It takes into account the navigation bar and PDP layout.
 */
export function useStickyPdpComponent() {
  const ctx = useContext()
  const isPreviewServer = ctx.$config.cst.isPreview
  const pdpStore = usePdpStore()
  const { isMobile } = useMobile()

  const additionalPreviewServerShift = isPreviewServer ? 38 : 0

  const desktopShift = computed(() => (pdpStore.showDesktopNavigation ? 208 : 112))
  const mobileShift = 112

  const documentSize = ref<number | undefined>()

  let resizeObserver: ResizeObserver

  onMounted(() => {
    documentSize.value = document.body.offsetHeight
    resizeObserver = new ResizeObserver((_entries) => {
      // height of a page can change, so create an observer that will
      // react to these changes
      documentSize.value = document.body.offsetHeight
    })
    resizeObserver.observe(document.body)
  })

  onUnmounted(() => {
    resizeObserver?.disconnect()
  })

  return useStickyComponent(() => ({
    topShift: (!isMobile.value ? desktopShift.value : mobileShift) + additionalPreviewServerShift,
    stickyStart: !isMobile.value ? 960 : 500,
    stickyStop: !isMobile.value && documentSize.value ? documentSize.value - 1000 : undefined,
  }))
}
